import axios from 'axios';

// config
import { PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOST_API_KEY,
  json: true,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'cache-control': 'no-cache',
  },
});

const isNetworkError = (err) => {
  let result = false;
  if (err.isAxiosError) {
    if (err.response?.status === 404) {
      result = false;
    } else if (err.response?.data?.success === false) {
      result = false;
    } else {
      result = true;
    }
  }

  return result;
};

let tryReloadApi = 1;
axiosInstance.interceptors.response.use(undefined, (error) => {
  const originalRequest = error.config;

  if (isNetworkError(error)) {
    console.log('isAxiosError', tryReloadApi, error?.request?._currentUrl, error?.isAxiosError);

    if (tryReloadApi <= 4) {
      tryReloadApi += 1;

      return new Promise((resolve) => {
        if (originalRequest) {
          setTimeout(() => {
            resolve(axiosInstance(originalRequest));
          }, 10000);
        }
      });
    }
  }

  tryReloadApi = 1;

  if (
    error.response &&
    (error.response.status === 403 || error.response.status === 401) &&
    typeof window !== 'undefined'
  ) {
    localStorage.removeItem('accessToken');
    alert('توکن شما منقضی شده یا دسترسی لازم را ندارید!');
    window.location.href = PATH_AUTH.login;
    return false;
  }

  // console.log(error?.response);
  return Promise.reject(isNetworkError(error) ? 'CONNECTION_FAILED' : error?.response?.data || error);
});

export default axiosInstance;
